package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.HourglassW500Rounded: ImageVector
    get() {
        if (_hourglassW500Rounded != null) {
            return _hourglassW500Rounded!!
        }
        _hourglassW500Rounded = Builder(name = "HourglassW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(322.87f, 797.13f)
                horizontalLineToRelative(314.26f)
                lineTo(637.13f, 680.0f)
                quadToRelative(0.0f, -65.04f, -46.04f, -111.09f)
                quadToRelative(-46.05f, -46.04f, -111.09f, -46.04f)
                reflectiveQuadToRelative(-111.09f, 46.04f)
                quadTo(322.87f, 614.96f, 322.87f, 680.0f)
                verticalLineToRelative(117.13f)
                close()
                moveTo(591.09f, 391.09f)
                quadToRelative(46.04f, -46.05f, 46.04f, -111.09f)
                verticalLineToRelative(-117.13f)
                lineTo(322.87f, 162.87f)
                lineTo(322.87f, 280.0f)
                quadToRelative(0.0f, 65.04f, 46.04f, 111.09f)
                quadToRelative(46.05f, 46.04f, 111.09f, 46.04f)
                reflectiveQuadToRelative(111.09f, -46.04f)
                close()
                moveTo(197.37f, 888.13f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(34.5f)
                lineTo(231.87f, 680.0f)
                quadToRelative(0.0f, -60.04f, 27.18f, -113.3f)
                quadToRelative(27.19f, -53.27f, 76.04f, -86.7f)
                quadToRelative(-48.85f, -33.43f, -76.04f, -86.7f)
                quadToRelative(-27.18f, -53.26f, -27.18f, -113.3f)
                verticalLineToRelative(-117.13f)
                horizontalLineToRelative(-34.5f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(565.26f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                horizontalLineToRelative(-34.5f)
                lineTo(728.13f, 280.0f)
                quadToRelative(0.0f, 60.04f, -27.06f, 113.3f)
                quadTo(674.0f, 446.57f, 624.91f, 480.0f)
                quadToRelative(49.09f, 33.43f, 76.16f, 86.7f)
                quadToRelative(27.06f, 53.26f, 27.06f, 113.3f)
                verticalLineToRelative(117.13f)
                horizontalLineToRelative(34.5f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(197.37f, 888.13f)
                close()
                moveTo(480.0f, 797.13f)
                close()
                moveTo(480.0f, 162.87f)
                close()
            }
        }
        .build()
        return _hourglassW500Rounded!!
    }

private var _hourglassW500Rounded: ImageVector? = null
